import {httpGet, httpPost} from "../utils/httpHelper";
import store from "../store";
import {resetFromAndToDate, setMoneyExplorerFromDate, setMoneyExplorerToData, resetExternalFromAndToDate, resetToAndDefaultFrom} from "./MoneyExplorerReducer";
import {isEmpty} from "../utils/validations";
import {showSystemErrorBlock} from "../core/actions/appActions";

export const getMoneyExplorerDrillDown = (data, fromDate, toDate) => {
    let apiUrl = '/service/moneyFlow/drilldown';
    // if (isEmpty(fromDate) && isEmpty(toDate)){
    //     apiUrl = '/service/moneyFlow/drilldown';
    // }else  if (!isEmpty(fromDate) && !isEmpty(toDate)){
    //     apiUrl = '/service/home/drilldown?fromDate='+fromDate+'&toDate='+toDate;
    // }else if (isEmpty(fromDate)){
    //     apiUrl = '/service/home/drilldown?toDate='+toDate;
    // }else if (isEmpty(toDate)){
    //     apiUrl = '/service/home/drilldown?fromDate='+fromDate;
    // }

    return httpPost(apiUrl, data)
        .then(res=>{
            return res;
        })
};

export const setFromDate = (date) =>{
    store.dispatch(setMoneyExplorerFromDate(date))
};

export const setToDate = (date) =>{
    store.dispatch(setMoneyExplorerToData(date))
};

export const resetFromAndToDateFilter = (date) =>{
    store.dispatch(resetFromAndToDate(date))
};

export const resetToAndDefaultFromDateFilter = (date) =>{
    store.dispatch(resetToAndDefaultFrom(date))
};

export const resetExternalFromAndToDateFilter = (date) =>{
    store.dispatch(resetExternalFromAndToDate(date))
};

export const getCurrentMonthDates = () => {
    return httpGet('/service/home/currentMonth/details')
        .then(res => {
                return res;
            }
        ).catch(()=>{
            store.dispatch(showSystemErrorBlock())
        })
};